import { createContext } from 'react';

const LocationContext = createContext({
  locations: [],
  userLocation: null,
});

export default LocationContext;
